import { observer } from "mobx-react";
import { Fragment, h } from "preact";
import { useRef, useState } from "preact/hooks";
import { t, translate } from "../../I18n";
import { FulfillmentSettingsTracking, } from "restaumatic-client";
import FulfillmentMethodSwitcher from "./FulfillmentMethodSwitcher";
import FulfillmentAddressModal from "./FulfillmentAddressModal";
import FulfillmentTimeModal from "./FulfillmentTimeModal";
import PreactModal from "../../components/PreactModal";
import RestaurantDeliveryAddressWarning from "../../components/RestaurantDeliveryAddressWarning";
function FulfillmentSettings(props) {
    const { restaurantName, orderDetails, methodOptions, methodController, timeController, fulfillmentTime, nextAvailableOrderingDate, geolocation, cartState, isFrame, } = props;
    const fulfillmentWidgetExtraClass = isFrame
        ? "m-fulfillment-widget--frame"
        : "";
    const address = [
        orderDetails.formattedAddress.firstLine,
        orderDetails.formattedAddress.secondLine,
    ]
        .filter((v) => Boolean(v))
        .join(", ");
    return (h(Fragment, null,
        h("article", { id: "fulfillment-settings", class: `m-fulfillment-widget ${fulfillmentWidgetExtraClass}` },
            h("div", { class: "m-fulfillment-widget__method" }, methodOptions.length === 1 ? (h(AddressButton, { isDelivery: orderDetails.isDelivery, isSingleFulfillmentMethod: true, singleBtnText: methodOptions[0].label, restaurantName: restaurantName, address: address, controller: methodController.deliveryAddressController, geolocation: geolocation })) : (h(FulfillmentMethodSwitcher, { options: methodOptions, controller: methodController.fields.fulfillmentMethod, 
                // NOTICE: This is a HACK to prevent focusing to the switcher (and as effect: auto scroll to the input) when the Cart modal is opened and value has been changed there
                // TODO: Try to remove it when the fulfillment method is not changed immediately on the same page (in the Cart), but only after the "Save" button is clicked (related to: B2C-256).
                isDisabled: cartState.isCartOpen, isFrame: isFrame }))),
            h("div", { className: "m-fulfillment-widget__address d-flex" },
                h(AddressButton, { isDelivery: orderDetails.isDelivery, isSingleFulfillmentMethod: false, restaurantName: restaurantName, address: address, controller: methodController.deliveryAddressController, geolocation: geolocation })),
            h("div", { className: "m-fulfillment-widget__time d-flex" },
                h(TimeButton, { fulfillmentTime: fulfillmentTime, controller: timeController, nextAvailableOrderingDate: nextAvailableOrderingDate }))),
        orderDetails.isDelivery && (h(RestaurantDeliveryAddressWarning, { state: orderDetails.deliveryAddressStatus.state }))));
}
const restoreFocus = (elementToFocus) => {
    elementToFocus.current && elementToFocus.current.focus();
};
const AddressButton = observer((props) => {
    const { isDelivery, isSingleFulfillmentMethod, singleBtnText, restaurantName, address, controller, geolocation, } = props;
    const addressBtnRef = useRef(null);
    const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
    const [isRestaurantModalOpen, setIsRestaurantModalOpen] = useState(false);
    const handleOpen = () => {
        if (isDelivery) {
            setIsAddressModalOpen(true);
        }
        else {
            setIsRestaurantModalOpen(true);
        }
    };
    const handleSubmit = () => {
        controller.save().then((succeed) => {
            if (succeed) {
                setIsAddressModalOpen(false);
            }
        });
    };
    const handleClose = () => {
        setIsAddressModalOpen(false);
        restoreFocus(addressBtnRef);
    };
    return (h(Fragment, null,
        isSingleFulfillmentMethod ? (h("button", { type: "button", ref: addressBtnRef, class: "btn btn-primary u-full-width u-full-height", "aria-label": translate(t.order.delivery_address), onClick: handleOpen }, singleBtnText)) : (h("button", { type: "button", ref: addressBtnRef, class: "m-fulfillment-widget__btn u-full-width", "aria-label": translate(t.order.delivery_address), onClick: handleOpen },
            h("span", { class: "m-fulfillment-widget__btn-icon icon-location", "aria-hidden": "true" }),
            h("span", { class: "m-fulfillment-widget__btn-text" }, address || translate(t.delivery_address.enter_address)))),
        h(FulfillmentAddressModal, { isOpen: isAddressModalOpen, controller: controller, geolocation: geolocation, onSubmit: handleSubmit, onShown: () => setIsAddressModalOpen(true), onHidden: handleClose }),
        h(RestaurantModal, { title: restaurantName, address: address, isOpen: isRestaurantModalOpen, onShown: () => setIsRestaurantModalOpen(true), onHidden: () => {
                setIsRestaurantModalOpen(false);
                restoreFocus(addressBtnRef);
            } })));
});
const TimeButton = observer((props) => {
    const { fulfillmentTime, controller, nextAvailableOrderingDate } = props;
    const timeBtnRef = useRef(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleSubmit = () => {
        setIsModalOpen(false);
        controller.submit();
        fulfillmentTime.save();
        FulfillmentSettingsTracking.chooseDateEvent({ tag: "Menu" });
    };
    const handleClose = () => {
        setIsModalOpen(false);
        restoreFocus(timeBtnRef);
        // NOTICE: this is a HACK to restore domain values when user clicks on modal's "X" button
        controller.clear();
        controller.restore();
    };
    return (h(Fragment, null,
        h("button", { type: "button", ref: timeBtnRef, class: "m-fulfillment-widget__btn u-full-width", "aria-label": translate(t.order.delivery_time), onClick: () => setIsModalOpen(true) },
            h("span", { class: "m-fulfillment-widget__btn-icon icon-time", "aria-hidden": "true" }),
            h("span", { class: "m-fulfillment-widget__btn-text u-text-capitalize" }, fulfillmentTime.formattedValue)),
        h(FulfillmentTimeModal, { isOpen: isModalOpen, fulfillmentTime: fulfillmentTime, controller: controller, nextAvailableOrderingDate: nextAvailableOrderingDate, onSubmit: handleSubmit, onShown: () => setIsModalOpen(true), onHidden: handleClose })));
});
const RestaurantModal = observer((props) => {
    const { title, address, isOpen, onShown, onHidden } = props;
    // TODO: Do translated routing mechanism
    const contactLink = `/kontakt`;
    return (h(PreactModal, { id: "restaurant-info", isOpen: isOpen, onShown: onShown, onHidden: onHidden },
        h("div", { class: "modal-header" },
            h("button", { type: "button", "data-bs-dismiss": "modal", class: "close", "aria-label": translate(t.generic.close) },
                h("span", { "aria-hidden": "true", class: "icon-cancel" })),
            h("h4", { class: "modal-title" }, title)),
        h("div", { class: "modal-body" },
            h("p", null, address),
            h("a", { href: contactLink }, translate(t.theme_defaults.contact.title))),
        h("div", { class: "modal-footer modal-footer--sticky" },
            h("button", { type: "button", "data-bs-dismiss": "modal", class: "btn btn-primary btn-block" }, translate(t.theme_defaults.creator.back_to_menu)))));
});
export default observer(FulfillmentSettings);
